<div class="container-fluid" style="overflow-y: auto;">
    <section>
		<header>
			<h1><span jhiTranslate="inventoryManagerApp.manage.inventory.title"> Manage Inventory</span>
				<jhi-help-link [helpLink]="helpLink"></jhi-help-link>
			</h1>
			<span jhiTranslate="inventoryManagerApp.manage.inventory.label">
				Browse, view, filter and manage inventory information.
			</span>
		</header>
        <nav class="pt-2">
            <ul class="nav nav-tabs">
                <li class="nav-item pe-1" *jhiHasAnyAuthority="VIEW_LOTS_PERMISSIONS">
                    <a class="nav-link"
                       [routerLink]="[{outlets:{'inventory-manager-outlet': 'lot'}}]"
                       [routerLinkActive]="['active']" queryParamsHandling="merge" data-test="viewLotsLink"
					   jhiTranslate="inventory-manager.action.view-lots">View Lots</a>
                </li>
                <li class="nav-item pe-1" *jhiHasAnyAuthority="VIEW_TRANSACTIONS_PERMISSIONS">
                    <a class="nav-link"
                       [routerLink]="[{outlets:{'inventory-manager-outlet': 'transaction'}}]"
                       [routerLinkActive]="['active']" queryParamsHandling="merge" data-test="viewTransactionsLink"
						jhiTranslate="inventory-manager.action.view-transactions">View Transactions</a>
                </li>
            </ul>
        </nav>
        <div class="tab-content p-3">
            <router-outlet name="inventory-manager-outlet"></router-outlet>
        </div>
    </section>
</div>
